module.exports = __webpack_public_path__ + "img/logo2.2fe6ebd2.png";